import { environment } from '../../environments/environment';

export class OskarOfferUrlBuilder {
	private url = '';
	private params = '?';
	constructor() {}

	private checkDev(): string {
		return environment.production ? '' : 'dev.';
	}

	setOfferUrl(productId) {
		this.url = `https://${this.checkDev()}oskar.com.pl/oferta/${productId}?`;
		return this;
	}

	setBoards(boards: number[]): OskarOfferUrlBuilder {
		this.params = this.params.includes('boards')
			? this.params.replace(/boards=.*&/, `boards=${boards}&`)
			: this.params.concat(`boards=${boards}&`);
		return this;
	}

	setDateRange(lower: string, upper: string): OskarOfferUrlBuilder {
		this.params = this.params.includes('date_range')
			? this.params.replace(/date_range=.*&/, `date_range=${lower},${upper}&`)
			: this.params.concat(`date_range=${lower},${upper}&`);
		return this;
	}

	setRoomType(roomType: number[]): OskarOfferUrlBuilder {
		this.params = this.params.includes('room_type')
			? this.params.replace(/room_type=.*&/, `room_type=${roomType}&`)
			: this.params.concat(`room_type=${roomType}&`);
		return this;
	}

	setOwnTransport(ownTransport: boolean): OskarOfferUrlBuilder {
		this.params = this.params.includes('own_transport')
			? this.params.replace(/own_transport=.*&/, `own_transport=${ownTransport}&`)
			: this.params.concat(`own_transport=${ownTransport}&`);
		return this;
	}

	setAdults(adultsCount: string): OskarOfferUrlBuilder {
		this.params = this.params.includes('adults')
			? this.params.replace(/adults=.*&/, `adults=${adultsCount}&`)
			: this.params.concat(`adults=${adultsCount}&`);
		return this;
	}

	setPromotion(promotion: number[]): OskarOfferUrlBuilder {
		this.params = this.params.includes('promotion_catalogs')
			? this.params.replace(/promotion_catalogs=.*&/, `promotion_catalogs=${promotion}&`)
			: this.params.concat(`promotion_catalogs=${promotion}&`);
		return this;
	}

	setChildren(childrenCount: number): OskarOfferUrlBuilder {
		this.params = this.params.includes('children')
			? this.params.replace(/children=.*&/, `children=${childrenCount}&`)
			: this.params.concat(`children=${childrenCount}&`);
		return this;
	}

	setConveniences(convenience: number[]): OskarOfferUrlBuilder {
		this.params = this.params.includes('conveniences')
			? this.params.replace(/conveniences=.*&/, `conveniences=${convenience}&`)
			: this.params.concat(`conveniences=${convenience}&`);
		return this;
	}

	setKinds(kinds: number[]): OskarOfferUrlBuilder {
		this.params = this.params.includes('kinds')
			? this.params.replace(/kinds=.*&/, `kinds=${kinds}&`)
			: this.params.concat(`kinds=${kinds}&`);
		return this;
	}

	setLocations(locations: number[]): OskarOfferUrlBuilder {
		this.params = this.params.includes('locations')
			? this.params.replace(/locations=.*&/, `locations=${locations}&`)
			: this.params.concat(`locations=${locations}&`);
		return this;
	}

	setMinNights(min: number): OskarOfferUrlBuilder {
		this.params = this.params.includes('nights_min')
			? this.params.replace(/nights_min=.*&/, `nights_min=${min}&`)
			: this.params.concat(`nights_min=${min}&`);
		return this;
	}

	setMaxNights(max: number): OskarOfferUrlBuilder {
		this.params = this.params.includes('nights_max')
			? this.params.replace(/nights_max=.*&/, `nights_max=${max}&`)
			: this.params.concat(`nights_max=${max}&`);
		return this;
	}

	setStops(stops: number[]): OskarOfferUrlBuilder {
		this.params = this.params.includes('stops')
			? this.params.replace(/stops=.*&/, `stops=${stops}&`)
			: this.params.concat(`stops=${stops}&`);
		return this;
	}

	setProduct(products: number[]): OskarOfferUrlBuilder {
		this.params = this.params.includes('products')
			? this.params.replace(/products=.*&/, `products=${products}&`)
			: this.params.concat(`products=${products}&`);
		return this;
	}

	setSellChannels(sellChannels: string[]): OskarOfferUrlBuilder {
		this.params = this.params.includes('sell_channels')
			? this.params.replace(/sell_channels=.*&/, `sell_channels=${sellChannels}&`)
			: this.params.concat(`sell_channels=${sellChannels}&`);
		return this;
	}

	clearParams() {
		this.params = '?';
		return this;
	}

	buildParams() {
		return this.params;
	}

	build() {
		return this.url + this.params;
	}
}
